import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from 'components/shared/DesignSystem/SlabTransferPortal/Text';

const FeatureListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_m);
`;

const FeatureContainer = styled.div`
  display: flex;
  gap: var(--cc_size_spacing_s);
  max-width: 500px;
`;

const FeatureIcon = styled.i`
  color: var(--cc_color_text_nonessential);
`;

const FeatureList = ({ features }) => {
  return (
    <FeatureListContainer>
      {features.map((feature) => {
        return (
          <FeatureContainer key={feature}>
            <FeatureIcon className="mdi mdi-check" />
            <Text size="s">{feature}</Text>
          </FeatureContainer>
        );
      })}
    </FeatureListContainer>
  );
};

FeatureList.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FeatureList;
